<template>
	<el-row class="searchTermReport">
		<el-col :span="24" class="searchTermReport-select">
			<client-module moduletitle="Google Ads搜索词报告">
				<!-- 网址切换 -->
				<sky-dropdown-select
					slot="customHint"
					class="site-list"
					@change="changeSite"
					v-model="serviceId"
					:options="websiteList"
					:props="{ label: 'name', value: 'id' }"
				></sky-dropdown-select>
				<div class="switch-content">
					<div class="time-switch">
						<skydropdown-select :options="groups" @change="selectChange" :value="selecttimetype">
						</skydropdown-select>
						<!-- 日期选择器 -->
						<el-date-picker
							v-model="startDate"
							:type="pickerType"
							:firstDayOfWeek="1"
							:format="format"
							:disabled="disabled"
							clearable
							@change="dataChange"
							placeholder="请选择日期"
							:picker-options="pickerOptions"
						>
						</el-date-picker>
						<div class="time-date" v-if="startDate">
							<span>{{ startDate }}</span>
							<span>至</span>
							<span>{{ endDate }}</span>
						</div>
					</div>
				</div>
			</client-module>
		</el-col>
		<!-- 数据总览 -->
		<el-col :span="24" class="data-overview" v-if="false">
			<client-module moduletitle="数据总览" hideBorder>
				<el-row type="flex" class="data-overview-list">
					<div class="placeholder"></div>
					<el-col v-for="item in overviewList" :key="item.id" class="data-overview-item">
						<div class="data-overview-header" :class="item.bgc">
							<div>
								<span class="number">{{ item.id }}</span>
								<span class="title">{{ item.title }}</span>
							</div>
							<div class="icon">
								<ig-icon :name="item.icon" customerSize="40"></ig-icon>
							</div>
						</div>
						<div class="data-overview-footer">
							<div class="all-data">
								<div class="data">{{ item.allData }}</div>
								<div class="title">全部</div>
							</div>
							<div class="added-data">
								<div class="data">{{ item.addedData }}</div>
								<div class="title">已添加</div>
							</div>
						</div>
					</el-col>
					<div class="placeholder"></div>
				</el-row>
			</client-module>
		</el-col>
		<!-- 图表 -->
		<el-col :span="24" class="searchData-charts">
			<client-module :moduletitle="searchNum" hideBorder>
				<div slot="event" class="event">
					<el-checkbox :value="checkouboxData" @change="checkboxChange">仅看已添加</el-checkbox>
				</div>
				<el-row type="flex" justify="space-between" align="center" class="charts">
					<!-- 柱状图 -->
					<el-col class="charts-bar" :span="12">
						<advertising-series
							:condition="condition"
							@googlereports="googlereports"
							@googlereportsPct="googlereportsPct"
						></advertising-series>
					</el-col>
					<!-- 饼图 -->
					<el-col class="charts-pie" :span="12">
						<advertising-series-pie
							:condition="conditionPie"
							@googlereportspie="googlereportspie"
						></advertising-series-pie>
					</el-col>
				</el-row>
			</client-module>
		</el-col>
		<!-- 搜索词 -->
		<el-col :span="24" class="search">
			<client-module moduletitle="报告详情数据" hideBorder>
				<filter-panel
					class="filter-panel"
					:data="swarchGroups"
					@search="filterChange"
					@change="fileChange"
				></filter-panel>
				<data-list
					ref="datalist"
					:table-style="{ name: 'mixture' }"
					:data="data"
					:columns="searchColumn"
					:btnList="btnList"
					:page="page"
					:loading="loading"
					:page-size="page.pageSize"
					@page-size-changed="pageSizeChanged"
					@page-changed="pageChanged"
					@sort-change="sortChange"
				>
				</data-list>
			</client-module>
		</el-col>
	</el-row>
</template>

<script>
import clientModule from '@/components/client/clientModule/clientModule';
import skydropdownSelect from '@/components/iglobalwin/formComponents/sky-dropdownSelect';
import { googleTimeSwitch, searchTermsType, searchTermsStatus } from '@/common/dictionary';
import { getWeekTime, transferDate, GetMonthStr } from '@/utils/index.js';
import { getDateRegion } from '@/common/util.js';
import filters from '@/mixins/filters.js';
import googleads from '@/backend/services/googleAds/googleAds.js';
import advertisingSeries from '@/components/client/clientCharts/advertising-series';
import advertisingSeriesPie from '@/components/client/clientCharts/advertising-series-pie';
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel.vue';
import listPageCreate from '@/mixins/listPageCreate';
import api from '@/backend/apiConfig/apiConfig';
import { mapGetters } from 'vuex';
import { getWebsiteByCustomer } from '@/backend/services/account/service';
import skyDropdownSelect from '@/components/iglobalwin/formComponents/sky-dropdownSelect';
import website from '@/backend/services/website/website.js';
import listCharts from '@/components/googleAdsCom/listCharts.vue';

const list = listPageCreate({
	searchConfig: {
		api: api.googleAds.searchList,
		method: 'POST',
		config: {
			timeout: 60000,
		},
	},
	getQuery(obj, that) {
		return _.assign(obj, {
			startDate: that.startDate,
			endDate: that.endDate,
			serviceId: that.serviceId,
		});
	},
});

let tooltipClickCallback;
window.onClickSeries = function (series) {
	if (tooltipClickCallback) {
		tooltipClickCallback(series);
	}
};
export default {
	name: 'searchTermReport',
	mixins: [list],
	data() {
		let that = this;
		return {
			groups: googleTimeSwitch,
			selecttimetype: 'WEEKLY',
			format: 'yyyy 第 WW 周',
			startDate: '',
			endDate: '',
			pickerType: 'week',
			pickerOptions: {
				disabledDate(time) {
					return that.dealDisabledDate(time);
				},
			},
			overviewList: [],
			googleAdsData: {},
			googleAdsDataPie: {},
			searchNum: '',
			searchTermStatus: '',
			condition: {},
			conditionPie: {},
			sortName: 'IMPRESSIONS',
			sortPctName: 'clickRate',
			sortNamePie: 'IMPRESSIONS',
			chartkey: '',
			swarchGroups: {},
			searchColumn: [],
			btnList: [],
			alert: {
				visible: false,
				type: 'success',
				title: '已选中3项',
				closeText: '清空',
				showIcon: true,
				close: () => {},
			},
			loading: false,
			expandRowKeys: [],
			serviceId: '',
			websiteList: [],
			WeeklyOlData: '',
			DailyOlData: '',
			MonthlyOlData: '',
		};
	},
	computed: {
		...mapGetters(['customerId', 'checkouboxData']),
	},
	watch: {
		customerId: {
			async handler(val) {
				let id = this.$route.query.id;
				let name = this.$route.query.name;
				if (id && name) {
					this.$store.commit('SET_CUSTOMERID', id);
					this.$store.commit('SET_CUSOMERNAME', name);
				}

				if (val || (id && name)) {
					this.disabled = false;
					this.setswitchTermw();
					this.getWebsite(val);
				} else {
					this.disabled = true;
					this.$message.warning('您需要先选择一个客户');
					this.setswitchTermw();
					this.$showCustomerDialog();
				}
			},
			immediate: true,
		},
	},
	mounted() {
		// 复制内容
		tooltipClickCallback = data => {
			this.$copyText(data).then(
				() => {
					this.$message.success('复制成功');
				},
				() => {
					this.$message.warn('复制失败');
				}
			);
		};
	},
	methods: {
		// 网站下拉数据
		async getWebsite(id) {
			try {
				let result = await getWebsiteByCustomer({
					customerId: id,
				});
				this.websiteList = result.data;
				if (result.data.length == 0) return false;
				this.serviceId = result.data[0].id;

				this.getWeek();
			} catch (error) {
				this.getWeek();
			}
		},
		// 切换网站
		changeSite() {
			this.selecttimetype = 'WEEKLY';
			this.format = 'yyyy 第 WW 周';
			this.pickerType = 'week';
			this.WeeklyOlData = '';
			this.DailyOlData = '';
			this.MonthlyOlData = '';
			this.page.currentPage = 1;
			this.getWeek();
		},
		fileChange(row, val) {
			if (row.label == '广告系列' && val.length !== 0) {
				this.setAdGroupIdList(val);
			}
			if (row.label == '广告系列' && val.length === 0) {
				this.swarchGroups.others.forEach(item => {
					if (item.label === '广告组') {
						item.options = [];
					}
				});
			}
		},
		// 获取广告系列
		async advertisingSeries() {
			let { serviceId, startDate, endDate } = this;
			let res = await website.advertisingSeries({
				serviceId,
				startDate,
				endDate,
			});

			this.swarchGroups.others.forEach(item => {
				if (item.label === '广告系列') {
					item.options = res.data;
				}
			});
		},
		// 设置广告组
		async setAdGroupIdList(val) {
			let { startDate, endDate, serviceId } = this;
			let res = await website.advertisingGroup({
				campaignIdList: val,
				serviceId,
				startDate,
				endDate,
			});
			this.swarchGroups.others.forEach(item => {
				if (item.label === '广告组') {
					item.options = res.data;
				}
			});
		},
		// 时间类型选择
		selectChange(val) {
			this.selecttime = '';
			this.page.currentPage = 1;
			this.selecttimetype = val;
			switch (val) {
				case 'WEEKLY':
					this.pickerType = 'week';
					this.format = 'yyyy 第 WW 周';
					this.dataPeriod = '前一周';

					if (this.WeeklyOlData) {
						this.dataChange(this.WeeklyOlData);
					} else {
						this.getWeek();
					}
					break;
				case 'DAILY':
					this.pickerType = 'date';
					this.format = 'yyyy-MM-dd';
					this.dataPeriod = '前一天';

					if (this.DailyOlData) {
						this.dataChange(this.DailyOlData);
					} else {
						this.getDetailDay();
					}
					break;
				case 'MONTHLY':
					this.pickerType = 'month';
					this.format = 'yyyy-MM';
					this.dataPeriod = '前一月';

					if (this.MonthlyOlData) {
						this.dataChange(this.MonthlyOlData);
					} else {
						this.getDetailMonth();
					}
					break;
				default:
					this.pickerType = 'week';
					break;
			}
		},
		// 时间选择
		dataChange(val) {
			this.page.currentPage = 1;
			if (!val) {
				this.getWeek();
				this.query();
				return false;
			}
			let { selecttimetype } = this;
			// 周报
			if (selecttimetype === 'WEEKLY') {
				this.WeeklyOlData = val;
				// 处理月份结束日期
				let weekEnd = val.getTime() + 6 * 24 * 3600 * 1000;
				weekEnd = transferDate(new Date(weekEnd));
				let time = transferDate(val);

				this.startDate = time;
				this.endDate = weekEnd;
			}
			// 日报
			if (selecttimetype === 'DAILY') {
				this.DailyOlData = val;
				let time = transferDate(val);

				this.startDate = time;
				this.endDate = time;
			}
			// 月报
			if (selecttimetype === 'MONTHLY') {
				this.MonthlyOlData = val;
				let time = transferDate(val);
				// 求指定月长度
				let M = val.getMonth() + 1;
				let Y = val.getFullYear();
				let lange = new Date(Y, M, 0).getDate();

				// 处理月份结束日期
				let arr = time.split('-');
				arr[2] = lange - 0;

				this.startDate = time;
				this.endDate = arr.join('-');
			}
			this.getGoogleData();
		},
		// 时间选择器返回限制
		dealDisabledDate(time) {
			let { selecttimetype } = this;
			if (selecttimetype === 'WEEKLY') {
				//按周日为一周的最后一天计算
				var week = new Date();
				//今天是这周的第几天
				var today = week.getDay() * 24 * 3600 * 1000;

				// 三个月的开始结束时间
				// let date = GetMonthStr(3, 'day')
				// let end = new Date(date.last).getTime()
				return time.getTime() > Date.now() - today; // || time.getTime() < end
			}
			if (selecttimetype === 'DAILY') {
				// 三个月的开始结束时间
				let date = GetMonthStr(3, 'day');
				let start = new Date(date.now).getTime();
				// let end = new Date(date.last).getTime()
				return time.getTime() > start; //|| time.getTime() < end
			}
			if (selecttimetype === 'MONTHLY') {
				// 三个月的开始结束时间
				// let date = GetMonthStr(3, 'day')
				// let end = new Date(date.last).getTime()
				return time.getTime() > Date.now(); //|| time.getTime() <div end
			}
		},
		// 获取时间初始值
		getWeek() {
			this.startDate = getWeekTime('start');
			this.endDate = getWeekTime('end');
			this.getGoogleData();
		},
		// 日报初始化
		getDetailDay() {
			this.startDate = getDateRegion('DAY').split('至')[0];
			this.endDate = getDateRegion('DAY').split('至')[1];
			this.getGoogleData();
		},
		// 月报初始化
		getDetailMonth() {
			this.startDate = getDateRegion('NEWMONTH').split('至')[0];
			this.endDate = getDateRegion('NEWMONTH').split('至')[1];
			this.getGoogleData();
		},
		// 数据请求
		getGoogleData() {
			this.advertisingSeries();
			this.getsearchDataView();
			this.getsearchDataViewPie();
			this.query();
		},
		// 获取数据总览
		async getsearchDataView() {
			try {
				let { startDate, endDate, searchTermStatus, checkouboxData, sortName, serviceId } = this;
				searchTermStatus = checkouboxData ? 1 : '';
				let res = await googleads.searchDataView({
					startDate,
					endDate,
					searchTermStatus,
					sortName,
					serviceId,
					sortType: 'DESC',
				});
				this.googleAdsData = res.data;
				let searchNum = checkouboxData ? res.data.searchTermTotalAdded : res.data.searchTermTotal;
				this.searchNum = `在这段周期内，共有${searchNum}个搜索词触发了您的广告`;
				let val = res.data || {};
				this.setCondition();
				this.overviewList = [
					{
						id: '01',
						title: '搜索词数量',
						icon: 'sousuocishuliang',
						bgc: 'searchNum',
						allData: filters.filters.thousands(val.searchTermTotal),
						addedData: filters.filters.thousands(val.searchTermTotalAdded),
					},
					{
						id: '02',
						title: '展示次数',
						icon: 'zscishu',
						bgc: 'showNum',
						allData: filters.filters.thousands(val.impressions),
						addedData: filters.filters.thousands(val.impressionsAdded),
					},
					{
						id: '03',
						title: '点击次数',
						icon: 'dianjicishu',
						bgc: 'clickNum',
						allData: filters.filters.thousands(val.clicks),
						addedData: filters.filters.thousands(val.clicksAdded),
					},
					{
						id: '04',
						title: '消耗',
						icon: 'xiaohao',
						bgc: 'consume',
						allData: filters.filters.rmb(val.exchangeRateCost),
						addedData: filters.filters.rmb(val.exchangeRateCostAdded),
					},
					{
						id: '05',
						title: '点击均价',
						icon: 'junjia',
						bgc: 'clickAverage',
						allData: filters.filters.rmb(val.clickAveragePrice),
						addedData: filters.filters.rmb(val.clickAveragePriceAdded),
					},
				];
			} catch (error) {
				this.$message.info('数据有误！');
			}
		},
		// 获取饼图数据
		async getsearchDataViewPie() {
			let { startDate, endDate, searchTermStatus, checkouboxData, sortNamePie, serviceId } = this;
			searchTermStatus = checkouboxData ? 1 : '';
			let res = await googleads.searchDataView({
				startDate,
				endDate,
				serviceId,
				searchTermStatus,
				sortName: sortNamePie,
				sortType: 'DESC',
			});
			this.googleAdsDataPie = res.data;
			this.setConditionPie();
		},
		// 仅看已添加
		checkboxChange(val) {
			this.$store.commit('SET_SEARCHDATACHECKBOXDATA', val);
			this.getsearchDataView();
			this.getsearchDataViewPie();
		},
		// 设置图表配置项
		setCondition() {
			let that = this;
			let [...data] = this.googleAdsData.listSearchTerm;
			data.map(item => {
				item.name = item.searchTermName;
				item.clickRate = item.clicksRate; // 点击率
				delete item.clicksRate;
				item.clickOnAverage = item.clickAveragePrice; // 点击均价
				delete item.clickAveragePrice;
			});
			this.condition = {
				data,
				extend: {
					tooltip: {
						enterable: true,
						trigger: 'axis',
						transitionDuration: 2,
						formatter: that.setExtend(data),
					},
				},
			};
		},
		// 设置饼图配置项
		setConditionPie() {
			let that = this;
			let [...data] = this.googleAdsDataPie.listSearchTerm;
			data.map(item => {
				if (item.searchTermName) {
					item.uniqueVal = item.adGroupId + item.campaignId + item.searchTermId;
					item.name = `${item.searchTermName}#${item.uniqueVal}`;
				} else {
					item.name = '';
				}
			});
			this.conditionPie = {
				data,
				extend: {
					tooltip: {
						enterable: true,
						trigger: 'item',
						transitionDuration: 2,
						formatter: that.setExtend(data),
					},
					series: {
						label: {
							show: true,
							formatter(data) {
								let val = data.name;
								return val.slice(0, val.indexOf('#'));
							},
						},
					},
					legend: {
						bottom: 30,
						formatter(val) {
							val = val.slice(0, val.indexOf('#'));
							var cArr = val.match(/[^\x00-\x80]/g);
							if (cArr) {
								if (cArr.length > 7 || val.length > 10) {
									val = val.slice(0, 6) + '...';
								}
							} else {
								if (val.length > 16) {
									val = val.slice(0, 10) + '...';
								}
							}
							var arr = [`{a|${val}}`].join('\n');
							return arr;
						},
						textStyle: {
							rich: {
								a: {
									width: 90,
									overflow: 'hidden',
									lineHeight: 10,
								},
							},
						},
					},
				},
			};
		},
		// 柱状图筛选
		googlereports(val) {
			this.sortName = val;
			this.getsearchDataView();
		},
		googlereportsPct(val) {
			this.sortPctName = val;
		},
		// 饼图筛选
		googlereportspie(val) {
			this.sortNamePie = val;
			this.getsearchDataViewPie();
		},
		setExtend(data) {
			return params => {
				let { sortName, sortPctName, sortNamePie } = this;
				let value;
				if (Array.isArray(params)) {
					value = params[0];
				} else {
					value = params;
				}
				let filterData = data[value.dataIndex];

				// 状态
				let customData = {};
				switch (filterData.searchTermStatus) {
					case '0':
						customData.status = '未知';
						break;
					case '1':
						customData.status = '已添加';
						break;
					case '2':
						customData.status = '已添加/已排除';
						break;
					case '3':
						customData.status = '已排除';
						break;
					case '4':
						customData.status = '未知';
						break;
					default:
						customData.status = '-';
				}
				switch (sortName) {
					case 'IMPRESSIONS':
						customData.leftData = `展示次数：${filters.filters.thousands(filterData.impressions)}`;
						break;
					case 'CLICKS':
						customData.leftData = `点击次数：${filters.filters.thousands(filterData.clicks)}`;
						break;
					case 'COST':
						customData.leftData = `消耗：${filters.filters.rmb(filterData.exchangeRateCost)}`;
						break;
					default:
						customData.leftData = '-';
						break;
				}
				switch (sortPctName) {
					case 'clickRate':
						customData.rightData = `点击率：${filters.filters.jojint(filterData.clickRate)}`;
						break;
					case 'clickOnAverage':
						customData.rightData = `点击均价：${filters.filters.rmb(filterData.clickOnAverage)}`;
						break;
					default:
						customData.rightData = '-';
						break;
				}
				switch (sortNamePie) {
					case 'IMPRESSIONS':
						customData.pieDataRate = `展示占比：${filters.filters.jojint(value.percent)}`;
						customData.pieData = `展示次数：${filters.filters.number(filterData.impressions)}`;
						break;
					case 'CLICKS':
						customData.pieDataRate = `点击占比：${filters.filters.jojint(value.percent)}`;
						customData.pieData = `点击次数：${filters.filters.number(filterData.clicks)}`;
						break;
					case 'COST':
						customData.pieDataRate = `消耗占比：${filters.filters.jojint(value.percent)}`;
						customData.pieData = `消耗：${filters.filters.rmb(filterData.exchangeRateCost)}`;
						break;
					default:
						customData.pieData = '-';
						break;
				}

				let dom = '<div>';
				// 公用dome
				dom +=
					'<div><div><span style="margin-right: 4px;">' +
					(filterData.searchTermName || '-') +
					'</span><span onclick="onClickSeries(\'' +
					(value.componentSubType === 'pie' ? filterData.searchTermName : filterData.name) +
					"','" +
					value.componentSubType +
					'\')"  class="iconfont icon-copy"></span></div><div>状态：' +
					customData.status +
					'</div>';
				// 柱状图dome
				if (value.componentSubType === 'bar' || value.componentSubType === 'line')
					dom += '<div>' + customData.leftData + '</div><div>' + customData.rightData + '</div>';
				// 饼图dome
				if (value.componentSubType === 'pie')
					dom += '<div>' + customData.pieDataRate + '</div><div>' + customData.pieData + '</div>';
				// 公用demo
				dom +=
					'<div>广告系列：' +
					(filterData.campaignName || '-') +
					'</div><div>广告组：' +
					(filterData.adGroupName || '-') +
					'</div></div>';
				dom += '</div>';
				return dom;
			};
		},
		// 搜索词配置
		setswitchTermw() {
			let that = this;
			let { disabled } = this;
			this.btnList = [
				{
					name: '客户提交列表',
					position: 'right',
					attribute: {
						type: 'primary',
						size: 'mini',
						disabled: disabled,
					},
					btnClick() {
						let { serviceId } = that;
						that.$router.push({
							name: 'customerSubmission',
							query: {
								serviceId,
							},
						});
					},
				},
				{
					name: '下载报告',
					position: 'right',
					attribute: {
						type: 'primary',
						size: 'mini',
						disabled: disabled,
					},
					btnClick() {
						that.searchTermsDownload();
					},
				},
			];
			this.swarchGroups = {
				others: [
					{
						tagName: 'sky-select',
						placeholder: '请选择',
						inputTitle: '匹配类型',
						label: '匹配类型',
						defaultText: '匹配类型',
						options: searchTermsType,
						prop: 'searchTermMatchType',
						value: '',
					},
					{
						tagName: 'sky-select',
						placeholder: '请选择',
						inputTitle: '状态',
						label: '状态',
						defaultText: '状态',
						options: searchTermsStatus,
						prop: 'searchTermStatus',
						value: '',
					},
					{
						tagName: 'sky-select',
						placeholder: '请选择',
						inputTitle: '广告系列',
						label: '广告系列',
						defaultText: '广告系列',
						multiple: true,
						options: [],
						props: {
							label: 'campaignName',
							value: 'campaignId',
						},
						prop: 'campaignIdList',
						value: [],
					},
					{
						tagName: 'sky-select',
						placeholder: '请选择',
						inputTitle: '广告组',
						label: '广告组',
						defaultText: '广告组',
						multiple: true,
						options: [],
						props: {
							label: 'adGroupName',
							value: 'adGroupId',
						},
						prop: 'adGroupIdList',
						value: [],
					},
					{
						tagName: 'sky-input',
						placeholder: '请输入',
						label: '搜索词',
						inputTitle: '搜索词',
						prop: 'searchTermName',
						clearable: true,
						value: '',
					},
				],
			};
			this.searchColumn = [
				{
					label: '',
					type: 'tableExpand',
					tagName: listCharts,
					custom: true,
					getListChartsData: that.getListChartsData,
				},
				{
					label: '搜索词',
					type: 'tooltip',
					bind: 'searchTermName',
					tag(val, row) {
						if (row.searchTermType) {
							return { content: '自定义' };
						} else {
							return false;
						}
					},
				},
				{
					label: '匹配类型',
					type: 'percentage',
					width: 180,
					bind: 'searchTermMatchType',
					showOverflowTooltip: true,
					content: '在Google上触发广告的搜索字词与您账号中实际关键字的相关程度',
					style: {
						overflow: 'hidden',
						'text-overflow': 'ellipsis',
						'white-space': 'nowrap',
					},
					dataStyle(val) {
						switch (val) {
							case '1':
								return '广泛匹配';
							case '2':
								return '完全匹配';
							case '3':
								return '精确匹配（紧密变体）';
							case '4':
								return '词组匹配（紧密变体）';
							case '5':
								return '词组匹配';
							case '8':
								return 'Ai Max';
							case '9':
								return 'Performance Max';
							default:
								return '-';
						}
					},
				},
				{
					label: '状态',
					type: 'textStatus',
					bind: 'searchTermStatus',
					content: '是否已经将当前搜索词作为关键字或否定关键字添加到账户中',
					width: 120,
					dataStyle(val) {
						switch (val) {
							case '1':
								return '已添加';
							case '2':
								return '已添加/已排除';
							case '3':
								return '已排除';
							case '4':
								return '未知';
						}
					},
					statusSty(val) {
						switch (val) {
							case '1':
								return {
									color: '#3DA1FF',
								};
							case '2':
								return {
									color: '#FF9FA4',
								};
							case '3':
								return {
									color: '#4FD2AA',
								};
							case '4':
								return {
									color: '#999999',
								};
						}
					},
				},
				{
					label: '消耗',
					type: 'percentage',
					bind: 'exchangeRateCost',
					showOverflowTooltip: true,
					align: 'right',
					width: 120,
					sort: 'COST',
					options: [
						{
							label: '由低到高',
							value: 'asc',
						},
						{
							label: '由高到低',
							value: 'desc',
						},
					],
					dataStyle(val) {
						return filters.filters.rmb(val);
					},
				},
				{
					label: '展示次数',
					bind: 'impressions',
					align: 'right',
					width: 120,
					sort: 'IMPRESSIONS',
					options: [
						{
							label: '由低到高',
							value: 'asc',
						},
						{
							label: '由高到低',
							value: 'desc',
						},
					],
				},
				{
					label: '点击次数',
					bind: 'clicks',
					align: 'right',
					width: 120,
					sort: 'CLICKS',
					options: [
						{
							label: '由低到高',
							value: 'asc',
						},
						{
							label: '由高到低',
							value: 'desc',
						},
					],
				},
				{
					label: '点击率',
					type: 'percentage',
					bind: 'clicksRate',
					align: 'right',
					width: 120,
					sort: 'CTR',
					options: [
						{
							label: '由低到高',
							value: 'asc',
						},
						{
							label: '由高到低',
							value: 'desc',
						},
					],
					dataStyle(val) {
						return filters.filters.jojint(val);
					},
				},
				{
					label: '点击均价',
					type: 'percentage',
					bind: 'clickAveragePrice',
					showOverflowTooltip: true,
					align: 'right',
					width: 120,
					sort: 'AVERAGE_CPC',
					options: [
						{
							label: '由低到高',
							value: 'asc',
						},
						{
							label: '由高到低',
							value: 'desc',
						},
					],
					dataStyle(val) {
						return filters.filters.rmb(val);
					},
				},
				{
					label: '关键词',
					bind: 'keywordsName',
					showOverflowTooltip: true,
				},
				{
					label: '广告系列',
					bind: 'campaignName',
					showOverflowTooltip: true,
				},
				{
					label: '广告组',
					bind: 'adGroupName',
					showOverflowTooltip: true,
				},
			];
		},
		// 下载搜索词报告
		async searchTermsDownload() {
			let { startDate, endDate, serviceId } = this;
			let res = await website.searchTermsDownload({
				serviceId,
				startDate,
				endDate,
			});

			if (!res.data) {
				this.$message.info('所选时间段暂无数据');
				return false;
			}
			this.download(res.data, '搜索词报告');
		},
		download(val, name) {
			let blob = new Blob([val]);
			let url = window.URL.createObjectURL(blob);
			let link = document.createElement('a');
			link.style.display = 'none';
			link.href = url;
			link.setAttribute('download', `${name}【${this.startDate}至${this.endDate}】.xlsx`);
			document.body.appendChild(link);
			link.click();
		},
		async getListChartsData(row) {
			try {
				let { startDate, endDate, serviceId } = this;
				let { adGroupId, campaignId, searchTermId, keywordsName, searchTermMatchType } = row;
				let res = await googleads.searchTermsCharts({
					startDate,
					endDate,
					searchTermId,
					serviceId,
					adGroupIdList: [adGroupId],
					campaignIdList: [campaignId],
					keyword: keywordsName,
					searchTermMatchType,
				});
				res.data.map(item => {
					item.name = item.selectPeriod;
					delete item.searchTermName;
					item.clickRate = item.clicksRate; // 点击率
					delete item.clicksRate;
					item.clickOnAverage = item.clickAveragePrice; // 点击均价
					delete item.clickAveragePrice;
				});
				let filed = {
					clicksRate: true,
					impressions: true,
					exchangeRateCost: true,
					clickRate: true,
					clickOnAverage: true,
				};
				res.data.map(item => {
					Object.keys(item).map(val => {
						if (filed[val] && item[val] === null) item[val] = 0;
					});
				});
				return res.data;
			} catch (error) {
				console.log(error);
				this.$message.info('图表数据请求失败');
				return [];
			}
		},
	},
	components: {
		clientModule,
		skydropdownSelect,
		advertisingSeries,
		advertisingSeriesPie,
		filterPanel,
		skyDropdownSelect,
	},
};
</script>

<style lang="scss" scoped>
#virtual-demo {
	pointer-events: all;
	background-color: red;
	color: red;
}
.virtual-demo {
	pointer-events: all;
	background-color: red;
	color: red;
}
.el-row {
	padding: 0 20px 20px;
	background-color: #f3f7ff;
	.searchTermReport-select {
		box-shadow: 0px 4px 4px 0px rgba(67, 93, 255, 0.05);
		border-radius: 4px;
		background-color: #fff;
		margin-bottom: 10px;
		.site-list {
			margin-left: 20px;
		}
		.switch-content {
			display: flex;
		}
		.time-switch {
			width: 650px;
			height: 60px;
			display: flex;
			align-items: center;
			padding: 0 24px;
			.el-date-editor {
				margin-left: 52px;
				.el-range-separator {
					padding: 0;
				}
			}
			.time-date {
				color: #666;
				margin-left: 20px;
				font-size: 16px;
			}
			.el-dropdown {
				color: #5aa0ff;
			}
		}
		.language-switch {
			width: 350px;
			&::before {
				content: '报告切换';
				width: 150px;
			}
		}
	}
	.data-overview {
		background-color: #fff;
		.data-overview-list {
			padding: 10px 0px 30px;
			background-color: #fff;
			overflow: auto;
			// 改变滚动条样式
			&::-webkit-scrollbar {
				height: 8px;
			}
			&::-webkit-scrollbar-thumb {
				background-color: #e8e8e8;
				border-radius: 6px;
			}
			&::-webkit-scrollbar-track {
				background-color: #fff;
				border-radius: 2px;
			}
			.placeholder {
				padding: 0 6px;
			}
			.data-overview-item {
				// width: 100%;
				min-width: 252px;
				height: 160px;
				box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
				border-radius: 10px;
				margin: 0 5px;
				overflow: hidden;
				.data-overview-header {
					width: 100%;
					height: 70px;
					padding: 0px 28px 0px 10px;
					display: flex;
					justify-content: space-between;
					align-items: center;
					.number {
						font-size: 44px;
						font-weight: bold;
						color: rgba(255, 255, 255, 0.4);
						line-height: 62px;
					}
					.title {
						font-size: 14px;
						color: rgba(255, 255, 255, 1);
						line-height: 22px;
						margin-left: 10px;
					}
					.iconfont {
						font-size: 30px;
						color: rgba(228, 228, 228, 0.4);
					}
					&.searchNum {
						background: linear-gradient(
							90deg,
							rgba(250, 133, 132, 1) 0%,
							rgba(255, 255, 255, 1) 100%
						);
					}
					&.showNum {
						background: linear-gradient(
							90deg,
							rgba(134, 123, 255, 1) 0%,
							rgba(255, 255, 255, 1) 100%
						);
					}
					&.clickNum {
						background: linear-gradient(
							90deg,
							rgba(235, 143, 194, 1) 0%,
							rgba(255, 255, 255, 1) 100%
						);
					}
					&.consume {
						background: linear-gradient(
							90deg,
							rgba(125, 191, 255, 1) 0%,
							rgba(255, 255, 255, 1) 100%
						);
					}
					&.clickAverage {
						background: linear-gradient(
							90deg,
							rgba(115, 115, 115, 1) 0%,
							rgba(255, 255, 255, 1) 100%
						);
					}
				}
				.data-overview-footer {
					width: 100%;
					height: 90px;
					display: flex;
					justify-content: space-between;
					align-items: center;
					.all-data,
					.added-data {
						flex: 1;
						height: 100%;
						text-align: center;
						padding-top: 14px;
						.data {
							font-size: 20px;
							line-height: 38px;
							font-weight: bold;
							color: #333;
							// 单行溢出
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
						}
						.title {
							font-size: 14px;
							line-height: 22px;
							color: #666;
						}
					}
				}
			}
		}
	}
	.searchData-charts {
		background-color: #fff;
		margin: 20px 0;
		.charts {
			background-color: #fff;
			padding: 10px;
			padding-bottom: 30px;
			.charts-bar,
			.charts-pie {
				margin: 0 10px;
				box-shadow: 0px 4px 4px 0px rgba(67, 93, 255, 0.05);
			}
		}
	}
	.search {
		width: 100%;
		margin: 0;
		background-color: #fff;
		.filter-panel {
			padding: 0 14px;
		}
	}
}
</style>
